<template>
<div>
  <Field
    :label="$t('DIAL_SETTINGS_REVENUE_RECOVERY')"
    :has-tooltip="true"
    :tooltip-text="tooltipText"
  >
    <template #element>
        <div class="col-sm-6 toggle-wrap">
          <MultipleToggle
            :value="override"
            :options="toggleOptions"
            @onToggle="onRevenueRecoveryChange"
          />
        </div>
    </template>
  </Field>
  <template v-if="override">
    <Field
      :label="$t('DIAL_SETTINGS_REVENUE_RECOVERY_CONNECTION')"
      :has-tooltip="true"
      :tooltip-text="$t('DIAL_SETTINGS_REVENUE_RECOVERY_CONNECTION_TT')"
    >
      <template #element>
        <div class="col-sm-9">
          <input
            v-model="currentSetting.callLengthReroute"
            placeholder="10"
            name="callLengthReroute"
            type="number"
            class="form-control input-sm"
            @change="onInputChange"
            @input="onInputChange"
            @wheel="$event.target.blur()"
          />
          <label v-t="'SECONDS'" class="control-label m-l-10" />
        </div>
      </template>
    </Field>
    <Field
      :label="$t('DIAL_SETTINGS_REVENUE_RECOVERY_ATTEMPTS')"
      :has-tooltip="true"
      :tooltip-text="$t('DIAL_SETTINGS_REVENUE_RECOVERY_ATTEMPTS_TT')"
    >
      <template #element>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="maxRerouteAttempts"
          rules="min_value:0|max_value:5"
          slim
        >
          <div :class="classes">
            <div class="col-sm-9">
              <input
                v-model="currentSetting.maxRerouteAttempts"
                placeholder="2"
                name="maxRerouteAttempts"
                type="number"
                class="form-control input-sm"
                @change="onInputChange"
                @input="onInputChange"
                @wheel="$event.target.blur()"
              />
              <label
                v-if="errors && errors[0]"
                v-t="'DIAL_SETTINGS_REVENUE_RECOVERY_ATTEMPTS_ERROR'"
                class="form-group__label-required m-l-10"
              />
            </div>
          </div>
        </ValidationProvider>
      </template>
    </Field>
  </template>
</div>
</template>

<script>
import { cloneDeep } from 'lodash';
import messages from './locales';
import sharedMessages from '@/core/locales';

import Field from '@/core/components/LabelAndElement/LabelAndElement';
import MultipleToggle from '@/core/components/MultipleToggle/MultipleToggle';

export default {
  name: 'RevenueRecovery',
  components: {
    Field,
    MultipleToggle
  }, 

  props: {
    toggleOptions: {
      type: Array,
      default() {
        return [
          { name: this.$t('USE_PARENT_SETTING'), value: null },
          { name: this.$t('ENABLED'), value: true },
          { name: this.$t('DISABLED'), value: false },
        ];
      },
    },
    setting: {
      type: Object,
      default() {
        return null;
      },
    },
    tooltipText: {
      type: String,
      default() {
        return this.$t('DIAL_SETTINGS_REVENUE_RECOVERY_TARGET_TT');
      }
    }
  },
  
  data() {
    return {
      override: null,
      currentSetting: null
    }
  },
  watch: {
    setting: {
      immediate: true,
      handler() {
        this.override = this.setting ? this.setting.enabled : null;
        this.currentSetting = this.setting ? cloneDeep(this.setting) : null;
      }
    }
  },
  methods: {
    onRevenueRecoveryChange(option) {
      this.override = option.value;
      if (this.override === null) {
        this.currentSetting = null;
      } else {
        this.currentSetting = {};
        this.currentSetting.enabled = this.override;
        if (!this.override) {
          this.removeOverrideFields();
        }
      }
      this.$emit('change', this.currentSetting);
    },
    onInputChange() {
      this.$emit('change', this.currentSetting);
    },
    removeOverrideFields() {
      delete this.currentSetting.callLengthReroute;
      delete this.currentSetting.maxRerouteAttempts;
    }
  },

  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>